import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ExistingIndexationsDispatcher } from "./Variable";

export interface ExistingIndexationsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ExistingIndexationsStatic extends BaseStore<ExistingIndexationsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ExistingIndexationsDispatcher, (actionData) => this.onExistingIndexationsStoreResponse(actionData));
    }

    public getLastResult(): ExistingIndexationsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ExistingIndexationsStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onExistingIndexationsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.actionType, data: actionData.payload });
                break;
                case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
